import './Subpage.scss';
import smoothscroll from 'smoothscroll-polyfill';
import 'instant.page';
class Subpage {
    constructor(node) {
        this.node = node;
        smoothscroll.polyfill();
    }
    init() {
        let t = this;
        // -- remove preload -- //
            if(document.readyState === 'complete') {
                document.body.classList.remove('preload');
            } else {
                document.addEventListener('readystatechange', function(e) {
                    if( e.target.readyState === 'complete' ) {
                        document.body.classList.remove('preload');
                    }
                });
            }
        // -- END -- //

        // -- # scroll on init -- //
            let hashElement = null;
            if( window.location.hash ) {
                hashElement = document.getElementById( window.location.hash.replace('#','') );
                if( hashElement ) {
                    setTimeout( () => {
                        t.scrollToElement( hashElement );
                    }, 100 );
                }
            }
        // -- END -- //

        // -- # scroll on click -- //
            let elements = {};
            document.querySelectorAll('a[href*="#"]').forEach( ( link, index ) => {
                
                if( document.getElementById( link.getAttribute('href').split('#')[1] ) ) {
                    elements[index] = document.getElementById( link.getAttribute('href').split('#')[1] );
                    link.addEventListener( 'click', ( e ) => {
                        e.preventDefault();
                        t.scrollToElement( elements[index] );
                    });
                }
            });
        // -- END -- //

        // -- popup check -- //
            if( document.body.hasAttribute('data-popup-id') ) {
                document.body.getAttribute('data-popup-id').split(',').forEach( ( ID, index ) => {
                    window.theme.methods.loadPopup( ID.split('-')[0], ID.split('-')[1] );
                });
            }
        // -- END -- //

        // -- load profitroom script -- //
            setTimeout( () => {
                this.loadScript();
            }, 500 ); 
        // -- END -- //


        // -- print -- //
            window.addEventListener('beforeprint', () => {
                document.querySelectorAll('.LazyAsset .LazyAsset__item:not(.wrapper__item--loaded)').forEach( ( item, index ) => {
                    item.classList.add('wrapper__item--loaded');
                    item.querySelector('source').setAttribute( 'srcset', item.querySelector('source').getAttribute('data-srcset') );
                });
            });
        // -- END -- //
    
    }
    loadScript() {
        let lang = 'pl';
        let dateObj = new Date();
        let date = dateObj.toISOString().split('T')[0];

        if( document.querySelector('html').hasAttribute('lang') && document.querySelector('html').getAttribute('lang') ) {
            lang = document.querySelector('html').getAttribute('lang').split('-')[0];
        }
        let script = document.createElement('script');
        script.src = "https://open.upperbooking.com/apartamentyaquarius1/Booking.js?locale="+lang;
        script.setAttribute('async', true);

        script.addEventListener('load', () => {
            console.log( 'Profitroom script init' );
            
            document.querySelectorAll('[data-profitroom]').forEach( ( button, index ) => {
                button.addEventListener('click', () => {
                    Booking.Open({
                        nights : '3',
                        checkin : date,
                    });
                    window.dataLayer.push({
                        'event' : 'profitroom_check_date',
                        'page_id' : document.body.getAttribute('data-page-id'),
                    });
                });
            });
            document.querySelectorAll('[data-profitroom_id]').forEach( ( button, index ) => {
                button.addEventListener('click', () => {
                    if( button.hasAttribute('data-profitroom_reservation_start_date') && button.getAttribute('data-profitroom_reservation_start_date') ) {

                        Booking.Open({
                            nights : '3',
                            checkin : button.getAttribute('data-profitroom_reservation_start_date'),
                            OfferID: button.getAttribute('data-profitroom_id')
                        });
                    } else {
                        Booking.Open({
                            nights : '3',
                            checkin : date,
                            OfferID: button.getAttribute('data-profitroom_id')
                        });
                    }

                    window.dataLayer.push({
                        'event' : 'package_check_availability_price',
                        'page_id' : document.body.getAttribute('data-page-id'),
                    });
                    
                });
            });
        });

        document.body.insertAdjacentElement('beforeend', script );


    }
    scrollToElement( node ) {
        let t = this;
        let nodeStyle = node.getBoundingClientRect();
        let scrollPosition = 0;

        // document.querySelector('.Header__info').classList.remove('active');
        // document.querySelector('.Header__content .content__button').classList.remove('active');

        if( node.closest('.BlockAccordion') ) {
            node.closest('.BlockAccordion').querySelector('.BlockAccordion__button').classList.add('active');
        }
        if( node.classList.contains('BlockAccordion') ) {
            node.querySelector('.BlockAccordion__button').classList.add('active');
        }
        
        scrollPosition = nodeStyle.top + window.scrollY;
        if( window.innerWidth <= 960 || top < 0 ) {
            scrollPosition = scrollPosition - document.querySelector('header').offsetHeight;
        }
        window.scrollTo({ 
            top: scrollPosition,
            left: 0,
            behavior: 'smooth' 
        });

        if( node.closest('.BlockAccordion') || node.classList.contains('BlockAccordion') ) {
            setTimeout(() => {
                window.scrollTo({ 
                    top: scrollPosition,
                    left: 0,
                    behavior: 'smooth' 
                });
            }, 500 ); 
        }

    }
}
JSModules['Subpage'] = Subpage;
export default Subpage;